import { DateChangeEvent, EventClickEvent, SchedulerEvent } from '@progress/kendo-angular-scheduler';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild
} from '@angular/core';
import { CalendarService } from '../../../services/calendar/calendar.service';
import { AuthService } from '../../../../auth/services/auth/auth.service';
import { MStaticClient, MStaticInter, MUser } from '@argalis-apps/models';
import * as moment from 'moment';
import { Resource } from '@progress/kendo-angular-scheduler';
import _ from 'lodash';

@Component({
  selector: 'ags-planning',
  templateUrl: './planning.component.html',
  styleUrls: ['./planning.component.scss']
})
export class PlanningComponent implements OnInit {
  @ViewChild('kendoScheduler') public kendoScheduler: ElementRef<HTMLElement>;
  @Output() dateClicked = new EventEmitter<SchedulerEvent>();

  @Input('staticRequest')
  set _staticRequest(value: MStaticClient.IStaticClientRequest | MStaticInter.IStaticInterRequest) {
    this.staticRequest = value;
  }
  public staticRequest: MStaticClient.IStaticClientRequest | MStaticInter.IStaticInterRequest = {} as
    | MStaticClient.IStaticClientRequest
    | MStaticInter.IStaticInterRequest;
  public selectedDate: Date = new Date(); // l evenement se planifie au joir J
  public events: SchedulerEvent[] = [];
  private eventSample: SchedulerEvent = {
    id: 1,
    title: 'Lorem Ipsum',
    start: new Date(2019, 11, 24),
    end: new Date(2019, 11, 25)
  };
  public resources: Resource[] = [];
  // les dates doivent etre au format new Date(annee,jsmonth,jsday)
  public userConnected: MUser.CUser;
  public loading = false;
  private previousStartDateRange;
  private previousEndDateRange;

  constructor(private calendarService: CalendarService, private authService: AuthService, private renderer: Renderer2) {
    this.userConnected = this.authService.userConnected || null;
  }

  ngOnInit() {
    this.dateClicked.emit(void 0);
  }

  convertDateToUTC(dateTemp) {
    const date = new Date(dateTemp);
    return new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      date.getUTCMinutes(),
      date.getUTCSeconds()
    );
  }

  getPlanning(dateRange?) {
    // vu que la méthode est appelé plein de fois, si on est dans une même vue, on ne fait rien
    if (
      moment(dateRange.start).isSame(this.previousStartDateRange) &&
      moment(dateRange.end).isSame(this.previousEndDateRange)
    ) {
      return;
    }
    this.loading = true;
    const idIntervenant = ((this.userConnected || ({} as any)).userInfo || ({} as any)).id;
    const bOst = ((this.userConnected || ({} as any)).userInfo || ({} as any)).b_ost;
    const startDateRange = dateRange && dateRange.start ? dateRange.start : new Date();
    const endDateRange =
      dateRange && dateRange.end ? dateRange.end : new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
    this.previousStartDateRange = startDateRange;
    this.previousEndDateRange = endDateRange;
    try {
      // on attend que le back renvoie les nouvelles données
      this.calendarService.getAllPlanning(idIntervenant, startDateRange, endDateRange, bOst).subscribe(
        (parentData: any) => {
          const planningData = parentData.planningData;
          this.resources = parentData.kendoResources;
          if (planningData) {
            this.events = planningData
              .map((session, i, allSessions) => {
                const start = session.start;
                const end = session.end;
                session.start = session.statut !== 'INDISPONIBLE' ? this.convertDateToUTC(start) : new Date(start);
                session.end = session.statut !== 'INDISPONIBLE' ? this.convertDateToUTC(end) : new Date(end);
                // au mois si on a une tranche le matin et une autre l'après-midi, on en affiche qu'un. NB: le back group par id session puis par iddate
                if (i > 0 && Math.abs(moment(endDateRange).diff(moment(startDateRange), 'days')) > 7) {
                  if (session.title === (allSessions[i - 1] || ({} as any)).title) {
                    if (
                      moment(session.start).dayOfYear() ===
                      moment((allSessions[i - 1] || ({} as any)).start).dayOfYear()
                    ) {
                      return;
                    }
                  }
                }
                return session;
              })
              .filter(session => !!session);
          }
          this.appliquerFiltre();
          this.loading = false;
          // une fois que le html est à jour, on rajoute les hover
          // setTimeout important, sinon la vue n'est pas encore mis à jour au moment du traitement
          setTimeout(() => this.addHoverToKendoDiv());
        },
        () => {
          this.events = [];
          this.loading = false;
        }
      );
    } catch (e) {
      this.loading = false;
    }
  }

  appliquerFiltre() {
    if (_.isEmpty(this.staticRequest)) return; // A l'initialisation, c'est un objet vide
    // TODO: appliquer un filtrage de this.events en fonction des filtres activés de this.staticRequest
  }

  // rajoute pour chaque balise cliquable un hover
  addHoverToKendoDiv() {
    if (this.kendoScheduler && this.kendoScheduler.nativeElement && this.kendoScheduler.nativeElement.children) {
      for (const child of <any>this.kendoScheduler.nativeElement.children) {
        const listSessions = child.querySelectorAll('div.k-event');
        if (listSessions.length) {
          for (const div of listSessions) {
            this.renderer.addClass(div, 'k-link');
            this.renderer.setStyle(div, 'cursor', 'pointer');
          }
        }
      }
    }
  }

  // au clique sur une session d'une date
  clickDate(event: EventClickEvent) {
    if (event && event.sender) {
      this.selectedDate = new Date(event.event.dataItem.start);
      this.dateClicked.emit(event.event.dataItem);
    }
  }

  // au chargement de kendoScheduler ou à chaque changement de date (mois/semaine/jour)
  dateDisplay(event: DateChangeEvent) {
    if (event && event.dateRange) {
      setTimeout(() => this.getPlanning(event.dateRange));
    }
  }
}
